import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {EducationMaterialFile} from "../../../../types/interfaces";
import {EditChildPhotoComponent} from "../../modals/edit-child-photo/edit-child-photo.component";
import {ModalController} from "@ionic/angular";
import {EducationalFileComponent} from "../../modals/educational-file/educational-file.component";

@Component({
    selector: 'app-all-materials',
    templateUrl: './all-materials.component.html',
    styleUrls: ['./all-materials.component.scss'],
})
export class AllMaterialsComponent implements OnInit {
    @Input() class: string = '';
    @Input() groupId: number | undefined = undefined;
    @Input() hideEducationMaterials: boolean = false;
    @Input() fileAccess: boolean = false;
    @Input() files: EducationMaterialFile[] | null = null;

    constructor(private router: Router, private modalCtrl: ModalController,) {
    }

    ngOnInit() {
    }


    async navigate(route: string) {
        this.router.navigate([route]);
    }

    async showFilesModal() {
        let modal = await this.modalCtrl.create({
            component: EducationalFileComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                files: this.files
            }
        });
        await modal.present();
    }
}
